import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GMDRoutingModule } from './GMD-routing.module';
import { GMDComponent } from './GMD.component';
import { FooterComponent } from './footer/footer.component';
import { DashboardNewComponent } from './dashboard-new/dashboard-new.component';
import { AxisSharedModule } from '../_shared/axis-shared.module';
import { ViewResultsComponent } from './view-results/view-results.component';
import { GmdDashboardSortingComponent } from './gmd-dashboard-sorting/gmd-dashboard-sorting.component';
import { GmdInformationComponent } from './gmd-information/gmd-information.component';
import { GmdContactComponent } from './gmd-contact/gmd-contact.component';
import { GmdLocationComponent } from './gmd-location/gmd-location.component';
import { GmdEditComponent } from './gmd-edit/gmd-edit.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule} from '@angular/forms';
import { LoadingService } from 'axis-components/components/loading/loading.service';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    GMDRoutingModule,
    AxisSharedModule,
    HttpClientModule,
    ReactiveFormsModule,
    PipesModule
  ],
  declarations: [GMDComponent, DashboardNewComponent, ViewResultsComponent, GmdDashboardSortingComponent,
  GmdInformationComponent, GmdContactComponent, GmdLocationComponent, GmdEditComponent],
  providers: [LoadingService]
})
export class GMDModule { }